import { useTranslation } from "react-i18next";

import { useMemberships, useSwitchOrg } from "@/lib/org";
import { useMe } from "@/lib/auth";

export function OrgSwitcher() {
  const { t } = useTranslation();
  const me = useMe();
  const memberships = useMemberships();
  const switchOrg = useSwitchOrg();
  const activeId = me.data?.active_org_id ?? null;

  if (memberships.length === 0) return null;
  if (memberships.length === 1) {
    const only = memberships[0]!;
    return <span className="pill">{only.org.name}</span>;
  }
  return (
    <label className="flex items-center gap-2 text-xs text-nb-text-2">
      {t("ui.orgSwitcher.activeOrg")}
      <select
        aria-label={t("ui.orgSwitcher.activeOrgAria")}
        value={activeId ?? ""}
        disabled={switchOrg.isPending}
        onChange={(e) => {
          const id = Number(e.target.value);
          if (Number.isFinite(id) && id !== activeId) {
            switchOrg.mutate(id);
          }
        }}
        className="rounded-md border border-nb-border bg-nb-surface px-2 py-1 text-sm text-nb-text focus:border-nb-mint focus:outline-none"
      >
        {memberships.map((m) => (
          <option key={m.id} value={m.org.id}>
            {m.org.name}
          </option>
        ))}
      </select>
    </label>
  );
}